(function() {
  function getLightboxAttributes() {
    const clickHandler = "if(!event.isTrusted)return;event.preventDefault();event.stopPropagation();(function(image){var gallery=image.closest('.new-gallery')||document;var images=Array.prototype.slice.call(gallery.querySelectorAll('.main-swiper .swiper-slide:not(.swiper-slide-duplicate)>img[data-gallery-zoom-src]'));var index=Math.max(images.indexOf(image),0);if(!images.length)return;var zoom=document.querySelector('[data-pdp-click-zoom]');if(zoom)zoom.remove();zoom=document.createElement('div');zoom.setAttribute('data-pdp-click-zoom','');zoom.setAttribute('role','dialog');zoom.setAttribute('aria-modal','true');zoom.style.cssText='position:fixed;inset:0;z-index:9999;display:flex;align-items:center;justify-content:center;padding:clamp(18px,4vw,56px);background:rgba(0,0,0,.86);cursor:zoom-out;';zoom.innerHTML='<button type=\"button\" aria-label=\"Close image zoom\" data-zoom-close style=\"position:absolute;top:18px;right:18px;z-index:1;width:44px;height:44px;border:0;border-radius:50%;background:#fff;color:#111;font-size:32px;line-height:1;cursor:pointer;\">&times;</button><button type=\"button\" aria-label=\"Previous image\" data-zoom-prev style=\"position:absolute;left:18px;top:50%;z-index:1;width:48px;height:48px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#111;font-size:42px;line-height:1;transform:translateY(-50%);cursor:pointer;\">‹</button><img alt=\"\" data-zoom-img style=\"display:block;max-width:min(100%,1500px);max-height:100%;border-radius:8px;object-fit:contain;user-select:none;-webkit-user-drag:none;\"><button type=\"button\" aria-label=\"Next image\" data-zoom-next style=\"position:absolute;right:18px;top:50%;z-index:1;width:48px;height:48px;border:0;border-radius:50%;background:rgba(255,255,255,.92);color:#111;font-size:42px;line-height:1;transform:translateY(-50%);cursor:pointer;\">›</button><p data-zoom-count style=\"position:absolute;bottom:18px;left:50%;margin:0;padding:6px 10px;border-radius:999px;background:rgba(255,255,255,.92);color:#111;font-size:12px;font-weight:700;line-height:1;transform:translateX(-50%);\"></p>';document.body.appendChild(zoom);var zoomImg=zoom.querySelector('[data-zoom-img]');var prev=zoom.querySelector('[data-zoom-prev]');var next=zoom.querySelector('[data-zoom-next]');var count=zoom.querySelector('[data-zoom-count]');var oldOverflow=document.body.style.overflow;function src(img){var value=img.getAttribute('data-gallery-zoom-src')||img.currentSrc||img.src||'';return value.replace(/([?&])width=\\d+/,'$1width=1800');}function show(i){index=(i+images.length)%images.length;zoomImg.src=src(images[index]);zoomImg.alt=images[index].alt||'';count.textContent=images.length>1?(index+1)+' / '+images.length:'';prev.hidden=images.length<2;next.hidden=images.length<2;}function close(){document.body.style.overflow=oldOverflow;document.removeEventListener('keydown',keys);zoom.remove();}function keys(e){if(e.key==='Escape')close();if(e.key==='ArrowLeft'){e.preventDefault();show(index-1);}if(e.key==='ArrowRight'){e.preventDefault();show(index+1);}}zoom.addEventListener('click',function(e){if(e.target===zoom||e.target.hasAttribute('data-zoom-close'))close();});prev.addEventListener('click',function(e){e.stopPropagation();show(index-1);});next.addEventListener('click',function(e){e.stopPropagation();show(index+1);});document.addEventListener('keydown',keys);document.body.style.overflow='hidden';show(index);zoom.querySelector('[data-zoom-close]').focus();})(this);";
    return `onclick="${clickHandler.replace(/"/g, '&quot;')}"`;
  }

  function initProductMediaGallery(context) {
    context = context || document;
    const thumbnailContainer = context.querySelector('.thumbnail-container');
    const mainImageContainer = context.querySelector('.main-image-container');
    if (!thumbnailContainer || !mainImageContainer) return null;

    function syncBedNewBadge(swiper) {
      const badge = mainImageContainer.querySelector('.epic-bed-gallery__new-badge');
      if (!badge || !swiper) return;
      badge.hidden = swiper.realIndex !== 0;
    }

    function setEqualHeights() {
      if (!thumbnailContainer || !mainImageContainer) return;
      if (window.innerWidth < 750) {
        thumbnailContainer.style.removeProperty('height');
        mainImageContainer.style.removeProperty('height');
        return;
      }
      const containerWidth = mainImageContainer.offsetWidth;
      const desiredHeight = Math.min(window.innerHeight * 0.7, containerWidth);
      thumbnailContainer.style.height = `${desiredHeight}px`;
      mainImageContainer.style.height = `${desiredHeight}px`;
    }

    setEqualHeights();
    window.addEventListener('resize', setEqualHeights);
    window.addEventListener('orientationchange', setEqualHeights);

    function getInitialSlide() {
      const galleryEl = context.querySelector('.new-gallery');
      const requestedSlide = galleryEl ? Number(galleryEl.dataset.initialSlide) : 0;
      const slideCount = context.querySelectorAll('.main-swiper .swiper-slide').length;
      if (!Number.isFinite(requestedSlide) || requestedSlide < 0 || requestedSlide >= slideCount) return 0;
      return requestedSlide;
    }

    const initialSlide = getInitialSlide();

    const thumbnailSwiperEl = context.querySelector(".thumbnail-swiper");
    let thumbnailSwiper = null;
    if (thumbnailSwiperEl) {
      thumbnailSwiper = new Swiper(thumbnailSwiperEl, {
        direction: "horizontal",
        breakpoints: {
          769: { direction: "vertical" }
        },
        slidesPerView: "auto",
        spaceBetween: 10,
        watchSlidesProgress: true,
        mousewheel: true,
        initialSlide: initialSlide,
        navigation: {
          nextEl: context.querySelector(".thumbnail-next"),
          prevEl: context.querySelector(".thumbnail-prev")
        },
        on: {
          init: function() {
            setTimeout(() => {
              const thumbCont = context.querySelector('.thumbnail-container');
              if (thumbCont) thumbCont.classList.add('thumbnail-container--gradient');
            }, 300);
          },
          reachEnd: function() {
            const thumbCont = context.querySelector('.thumbnail-container');
            if (thumbCont) thumbCont.classList.remove('thumbnail-container--gradient');
          },
          fromEdge: function() {
            const thumbCont = context.querySelector('.thumbnail-container');
            if (thumbCont) thumbCont.classList.add('thumbnail-container--gradient');
          }
        }
      });
    }

    const mainSwiperEl = context.querySelector(".main-swiper");
    let mainSwiper = null;
    if (mainSwiperEl) {
      mainSwiper = new Swiper(mainSwiperEl, {
        spaceBetween: 10,
        initialSlide: initialSlide,
        navigation: {
          nextEl: context.querySelector(".nav-button-next"),
          prevEl: context.querySelector(".nav-button-prev")
        },
        thumbs: {
          swiper: thumbnailSwiper
        },
        lazy: {
          loadPrevNext: true,
        },
        on: {
          slideChange: function() {
            syncBedNewBadge(this);
          }
        }
      });
      syncBedNewBadge(mainSwiper);
    }

    if (mainSwiper && initialSlide > 0) {
      requestAnimationFrame(() => {
        if (!window.EG_PDP_VARIANT_INTERACTED && mainSwiper.slides.length > initialSlide) {
          mainSwiper.slideTo(initialSlide, 0, false);
          if (thumbnailSwiper) thumbnailSwiper.slideTo(initialSlide, 0, false);
        }
      });
    }

    // Make thumbnails clickable
    context.querySelectorAll(".thumbnail-swiper .swiper-slide").forEach((slide, index) => {
      slide.addEventListener("click", () => {
        if (mainSwiper) mainSwiper.slideTo(index);
        if (window.innerWidth >= 769) {
          thumbnailSwiper.el.scrollTop = slide.offsetTop - 100;
        } else {
          thumbnailSwiper.el.scrollLeft = slide.offsetLeft - 50;
        }
      });
    });

    return { mainSwiper, thumbnailSwiper };
  }

  window.initProductMediaGallery = initProductMediaGallery;

  document.addEventListener("DOMContentLoaded", function () {
    window.currentProductMediaGallery = window.initProductMediaGallery(document);
  });

  // --- Variant change: rebuild gallery with new variant's images ---
  function rebindThumbnailClicks(context) {
    context = context || document;
    context.querySelectorAll(".thumbnail-swiper .swiper-slide").forEach((slide, index) => {
      slide.addEventListener("click", () => {
        const gallery = window.currentProductMediaGallery;
        if (gallery && gallery.mainSwiper) gallery.mainSwiper.slideTo(index);
        if (gallery && gallery.thumbnailSwiper) {
          if (window.innerWidth >= 769) {
            gallery.thumbnailSwiper.el.scrollTop = slide.offsetTop - 100;
          } else {
            gallery.thumbnailSwiper.el.scrollLeft = slide.offsetLeft - 50;
          }
        }
      });
    });
  }

  let lastRebuiltVariantId = null;

  function settleGalleryOnFeaturedImage(gallery) {
    if (!gallery) return;

    const resetToFirstSlide = () => {
      if (gallery.mainSwiper && !gallery.mainSwiper.destroyed) {
        gallery.mainSwiper.update();
        gallery.mainSwiper.slideTo(0, 0, false);
      }
      if (gallery.thumbnailSwiper && !gallery.thumbnailSwiper.destroyed) {
        gallery.thumbnailSwiper.update();
        gallery.thumbnailSwiper.slideTo(0, 0, false);
      }
    };

    resetToFirstSlide();
    requestAnimationFrame(resetToFirstSlide);
  }

  function rebuildGallery(variantId) {
    const normalizedVariantId = String(variantId);
    if (normalizedVariantId === lastRebuiltVariantId) return true;

    const data = (window.variantGalleryData || {})[normalizedVariantId];
    if (!data) return false;

    // Build slides array: featured first, then color-matched/shared lifestyle images, then metafield extras.
    const slides = [];
    if (data.featured_image) {
      slides.push({
        src:   data.featured_image,
        thumb: data.featured_image_thumb,
        alt:   data.featured_image_alt || ''
      });
    }
    (data.lifestyle_images || []).forEach(img => slides.push(img));
    (data.extra_images || []).forEach(img => slides.push(img));
    if (!slides.length) return false;
    lastRebuiltVariantId = normalizedVariantId;

    // Rebuild thumbnail slides
    const thumbWrapper = document.getElementById('thumbnail-swiper-wrapper');
    if (thumbWrapper) {
      thumbWrapper.innerHTML = slides.map(img =>
        `<div class="swiper-slide">
          <img src="${img.thumb}" width="80" height="80" alt="${img.alt}" loading="lazy">
        </div>`
      ).join('');
    }

    // Rebuild main slides
    const mainWrapper = document.getElementById('main-swiper-wrapper');
    if (mainWrapper) {
      const lightboxAttrs = getLightboxAttributes();
      mainWrapper.innerHTML = slides.map(img =>
        `<div class="swiper-slide">
          <img src="${img.src}" data-gallery-zoom-src="${img.src.replace(/([?&])width=\\d+/, '$1width=1800')}" ${lightboxAttrs} width="400" height="400" alt="${img.alt}" loading="lazy">
        </div>`
      ).join('');
    }

    // Destroy old Swiper instances and re-initialize from scratch
    // This is the most reliable approach after replacing slide HTML
    if (window.currentProductMediaGallery) {
      if (window.currentProductMediaGallery.mainSwiper) {
        window.currentProductMediaGallery.mainSwiper.destroy(true, true);
      }
      if (window.currentProductMediaGallery.thumbnailSwiper) {
        window.currentProductMediaGallery.thumbnailSwiper.destroy(true, true);
      }
    }

    window.currentProductMediaGallery = window.initProductMediaGallery(document);
    settleGalleryOnFeaturedImage(window.currentProductMediaGallery);
    rebindThumbnailClicks(document);
    return true;
  }

  window.EpicProductMediaGallery = window.EpicProductMediaGallery || {};
  window.EpicProductMediaGallery.rebuild = rebuildGallery;

  function shouldSyncGalleryToVariant() {
    return Boolean(window.EG_PDP_VARIANT_INTERACTED);
  }

  // Hook into the variant change queue pattern used across sections
  if (!window.onVariantChange) {
    window.__variantChangeQueue = window.__variantChangeQueue || [];
    window.onVariantChange = function(fn) { window.__variantChangeQueue.push(fn); };
  }
  window.onVariantChange(function(vid) {
    if (!shouldSyncGalleryToVariant()) return;
    rebuildGallery(vid);
  });

  // Also listen for Dawn's native variantChange pub/sub event
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function(event) {
      if (!shouldSyncGalleryToVariant()) return;
      const variant = event.data && event.data.variant;
      if (variant && variant.id) rebuildGallery(variant.id);
    });
  }

  // Handle direct ?variant= URL loads
  document.addEventListener('DOMContentLoaded', function() {
    if (!shouldSyncGalleryToVariant()) return;
    const vid = new URLSearchParams(window.location.search).get('variant');
    if (vid) rebuildGallery(vid);
  });

})();
